import Layout from '@/views/account/Layout.vue';
import Login from '@/views/account/Login.vue';

export default {
    path: '/login',
    component: Layout,
    children: [
        { path: '', component: Login }
    ]
};